import { convertQFSymbolPositions } from "quickfire/integration/util/quickfire-utils";
import quickfire from "quickfire/quickfire";
import Record from "slotworks/model/gameplay/records/record";
import FreespinWinResult from "slotworks/model/gameplay/records/results/freespin-win-result";
import Result from "slotworks/model/gameplay/records/results/result";
import ScatterResult from "slotworks/model/gameplay/records/results/scatter-result";
import slotDefinition from "slotworks/model/slot-definition";
import { ResultBuilder } from "slotworks/server/builders/result-builder";

class ScatterResultBuilder implements ResultBuilder {

    public filter(data: any): boolean {
        const win = data as QuickfireWin;
        return parseInt(win.attributes.payline) === -1 && !win.attributes.ways;
    }

    public build(record: Record, win: QuickfireWin, packet: QuickfireResponsePacket): Result[] {

        const results = [];

        const winAttributes = win.attributes;
        const qfPaytablePayout = quickfire.paytable.get(winAttributes.paytableId);

        const symbolDef = slotDefinition.symbolDefinitions[qfPaytablePayout.symbolIndex];

        const result = new ScatterResult();
        result.symbolType = symbolDef.id;
        result.cashWon = parseInt(winAttributes.amount);
        result.positions = convertQFSymbolPositions(winAttributes.winSymbols);
        result.matches = result.positions.length;

        results.push(result);

        if (qfPaytablePayout.freespins) {
            const freespinWinResult = new FreespinWinResult();
            freespinWinResult.freespinsWon = qfPaytablePayout.freespinsAwarded;

            freespinWinResult.linkedResult = result;
            result.linkedResult = freespinWinResult;

            results.push(freespinWinResult);
        }

        return results;
    }
}

export default new ScatterResultBuilder();
